module.exports = __webpack_public_path__ + "img/arrow.0ee333da.svg";